export enum RoleType {
    Group = 1,
    User = 2,
    Hidden = 3
}
